/* ============================================================
   SOLIA — Shopify link map.
   Load this RIGHT AFTER solia-lib.jsx in every Solia section
   (core + new). It mutates window.SOLIA_LINKS in place so the
   global Nav/Footer and every page resolve to real Shopify routes.
   No imports/exports. Safe to load on any page.
   ============================================================ */
(function () {
    var ROUTES = {
        home: '/',
        shop: '/pages/shop',
        story: '/pages/our-story',
        science: '/pages/science',
        flavors: '/pages/flavors',
        reviews: '/pages/reviews',
        coconutLime: '/products/coconut-lime',
        pog: '/products/passion-orange-guava',
        contact: '/pages/contact',
        shippingReturns: '/pages/shipping-returns',
        wholesale: '/pages/wholesale',
        affiliates: '/pages/affiliates',
        faq: '/pages/faq',
        glp1: '/pages/for-glp-1-users',
        peptides: '/pages/for-peptide-users',
        cart: '/cart',
        login: '/account/login',
        account: '/account',
        accountHub: '/account',
        subscriptions: '/pages/subscriptions',
        privacy: '/policies/privacy-policy',
        terms: '/policies/terms-of-service',
        quiz: '/pages/glp-1-support-quiz',
        drinkMix: '/pages/glp-1-support-drink-mix',
        supplement: '/pages/supplement-for-glp-1-users',
        hydration: '/pages/hydration-support',
        digestive: '/pages/digestive-support',
        nutritionLower: '/pages/nutrition-support-lower-appetite',
        whatToDrink: '/pages/what-to-drink-on-glp-1s',
        vsDiy: '/pages/solia-vs-diy-stack',
        companionComplex: '/pages/companion-complex',
        qualityTesting: '/pages/quality-testing',
        supplementFacts: '/pages/supplement-facts',
        safetyAllergen: '/pages/safety-allergen',
        varietyPack: '/pages/shop',
        startChecklist: '/pages/starting-glp-1-nutrition-checklist',
        starterKit: '/pages/glp-1-starter-kit-guide',
        maintenance: '/pages/glp-1-maintenance-support',
        morningRoutine: '/pages/morning-routine-glp-1',
        travelRoutine: '/pages/travel-routine-glp-1',
        semaglutide: '/pages/semaglutide-nutrition-support',
        tirzepatide: '/pages/tirzepatide-nutrition-support',
        peptideSupport: '/pages/peptide-weight-loss-support',
        electrolytes: '/pages/electrolytes-coconut-water',
        fiberMagnesium: '/pages/prebiotic-fiber-magnesium',
        creatineAminos: '/pages/creatine-amino-acids',
        collagenSkin: '/pages/collagen-vitamin-c-skin',
        bVitamins: '/pages/b-vitamins-energy-metabolism',
        vsElectrolyte: '/pages/solia-vs-electrolyte-drinks',
        vsProtein: '/pages/solia-vs-protein-shakes'
    };
    window.SOLIA_LINKS = window.SOLIA_LINKS || {};
    for (var k in ROUTES) {
        window.SOLIA_LINKS[k] = ROUTES[k];
    }
})();
